import { map } from '../conf/appid';

/**
 * return appid/appkey from domain name function
 * Example: `var appData = appid(window.document.domain)`
 * @return {Object} appid and appkey of current page domain
 */
export function appid (domain) {
  var appidKey = {};
  switch (domain) {
    case 'live.xueersi.com':
      // 区分文理科,并且区分是回放还是直播
      var _appid = '';
      var _appkey = '';
      if (window.isArtsConfig === 0 || !window.isArtsConfig) {
        // 理科或者不区分的时
        // 判断是回放还是直播
        if (window.isPlayBack === 0 || !window.isPlayBack) {
          // 直播
          _appid = '1000033';
          _appkey = '256ddeb9e5ebd9cf965ef659934518c2';
        } else if (window.isPlayBack === 1) {
          // 回放
          _appid = '1000036';
          // 线上环境
          _appkey = '0ce62906d89f19d7ec2b1cae9a2fed43';
          // 测试环境
          // _appkey = 'cea2729baa8bea0791846300989459aa';
        }
      } else if (window.isArtsConfig === 1) {
        // 文科
        // 判断是回放还是直播
        if (window.isPlayBack === 0 || !window.isPlayBack) {
          // 直播
          _appid = '1000034';
          _appkey = 'de1647f61b853fb7361e02e5e99bed8f';
        } else if (window.isPlayBack === 1) {
          // 回放
          _appid = '1000037';
          // 线上环境
          _appkey = '83453d00f5486862e97d75968045579b';
          // 测试环境
          // _appkey = 'f02b5377fd55de28bf96adf9e1bde717';
        }
      }
      // 赋值
      appidKey = {
        appid: _appid,
        appkey: _appkey
      };
      break;
    case 'video.xueersi.com':
      // 区分文理科
      var videoAppid = '';
      var videoAppkey = '';
      if (window.isArtsConfig === 0 || !window.isArtsConfig) {
        // 理科或者不区分的时
        videoAppid = '1000036';
        videoAppkey = '0ce62906d89f19d7ec2b1cae9a2fed43';
      } else if (window.isArtsConfig === 1) {
        // 文科
        videoAppid = '1000037';
        videoAppkey = '83453d00f5486862e97d75968045579b';
      }
      // 赋值
      appidKey = {
        appid: videoAppid,
        appkey: videoAppkey
      };
      break;
    default:
      if (domain in map) {
        appidKey = map[domain];
      }
  }
  return appidKey;
}
